var _circle, _path, _path2, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.26392V42.7361C3.51323 38.3378 0 31.5792 0 24 0 16.4209 3.51323 9.66229 9 5.26392zM39 42.7361C44.4868 38.3378 48 31.5792 48 24 48 16.4209 44.4868 9.66228 39 5.26392V42.7361z",
    fill: "#E62048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20L16 21L17 19L20 22.5L20.5 21.5L19.5 15.5L21.5 16L24 12L26.5 16L28.5 15.5L27.5 21.5L28 22.5L31 19L31.5 21L35.5 20L34 24.5L36 25L30 30V32L24.5 31.5V38H23.5V31.5L18 32V30L12 25L14 24.5L12.5 20Z",
    fill: "#E62048"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgCa;